import { useState, useEffect } from 'react';
import {
  collection,
  query,
  where,
  getDocs,
} from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuth } from '../context/AuthContext';

export function useUsageStats() {
  const { currentUser, userData } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setStats(null);
      setLoading(false);
      return;
    }

    const fetchStats = async () => {
      setLoading(true);
      try {
        // Fetch projects
        const projectsQuery = query(
          collection(db, 'projects'),
          where('userId', '==', currentUser.uid)
        );
        const projectsSnapshot = await getDocs(projectsQuery);

        // Fetch documents
        const documentsQuery = query(
          collection(db, 'documents'),
          where('userId', '==', currentUser.uid)
        );
        const documentsSnapshot = await getDocs(documentsQuery);

        const documents = documentsSnapshot.docs.map((d) => d.data());

        // Aggregate stats
        const totalPages = documents.reduce((sum, d) => sum + (d.pageCount || 0), 0);
        const totalPiiItems = documents.reduce((sum, d) => sum + (d.piiItemCount || 0), 0);
        const totalCreditsUsed = documents.reduce((sum, d) => sum + (d.creditsUsed || 0), 0);

        // Document status breakdown
        const statusBreakdown = {};
        documents.forEach((d) => {
          const status = d.status || 'unknown';
          statusBreakdown[status] = (statusBreakdown[status] || 0) + 1;
        });

        setStats({
          totalProjects: projectsSnapshot.size,
          totalDocuments: documentsSnapshot.size,
          totalPages,
          totalCreditsUsed: totalCreditsUsed || (userData?.totalPurchased || 0) - (userData?.credits || 0),
          totalPiiItems,
          statusBreakdown,
        });
      } catch (err) {
        console.error('Error fetching usage stats:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [currentUser, userData?.totalPurchased, userData?.credits]);

  return { stats, loading };
}
